import React, { useState } from 'react';
import { Link } from 'react-router-dom'

const Speciality = (props) => {

    const [datatext] = useState({
        subtitle: 'Servicios',
        title: 'Todo lo que necesitas para disfrutar de tu estancia',
        desc: 'En Hostel Rodex te ofrecemos una experiencia cómoda y divertida.'
    })

    const serviciosList = [
        'Wifi', 'Desayuno Buffet', 'Aire Acondicionado', 'Calefacción',
        'Pileta', 'Yoga', 'Sala de Música', 'Cocina Equipada',
        'Terraza', 'Parrilla', 'Living', 'Sala con TV',
        'Lavadero', 'Biblioteca', 'Cochera', 'Vestuario Femenino',
        'Cowork', 'Actividades Recreativas'
    ];

    const data = props.data;

    return (
        <section className="tf-section section-speciality" style={{ paddingBottom: '40px' }}>
            <div className="container">
                <div className="row" style={{ alignItems: 'flex-start' }}>
                    <div className="col-xl-5 col-md-12">
                        <div className="block-text text-black pd-0" style={{ marginTop: '-60px' }}>
                            <h5 className="sub-title mb-10" data-aos="fade-up" data-aos-duration="1000">{datatext.subtitle}</h5>
                            <h3 className="title mb-28" data-aos="fade-up" data-aos-duration="1000">{datatext.title}</h3>
                            <p className="fs-21" data-aos="fade-up" data-aos-duration="1000">{datatext.desc}</p>

                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginTop: '35px' }} data-aos="fade-up" data-aos-duration="1200">
                                {serviciosList.map((servicio, i) => (
                                    <span key={i} style={{
                                        padding: '8px 18px',
                                        backgroundColor: '#fff0ec',
                                        color: '#df4421',
                                        borderRadius: '30px',
                                        fontSize: '15px',
                                        fontWeight: '600',
                                        border: '1px solid #df4421',
                                        boxShadow: '0 2px 5px rgba(223, 68, 33, 0.15)'
                                    }}>
                                        {servicio}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-7 col-md-12">
                        <div className="section-speciality__box">
                            {
                                data.map((data, index) => (
                                    <div key={index} className={`box-item bg-2 ${data.class}`} data-aos="flip-left" style={{ padding: 0, overflow: 'hidden', borderRadius: '20px' }}>
                                        <img src={data.img} alt={data.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Speciality;